import React, { useState } from "react"
import { FiUserCheck, FiMoreVertical, FiX } from "react-icons/fi"
import InfoPopover from "../../ui/InfoPopover"


export default function RepresentativeSection({
  disabled = false,
  officeLabel = "EUIPO"
}: {
  disabled?: boolean
  officeLabel?: string
}) {

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [showMore, setShowMore] = useState(false)

  return (
    <section>
      <h2 className="mb-3 flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wide text-gray-400">
        {officeLabel} Representative
        <InfoPopover text={`Representative before the ${officeLabel}`} />
      </h2>

      <div className="rounded-xl border border-gray-200 bg-white p-3.5 shadow-sm">
        <div className="flex items-start gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#e0f0f2] text-[#0e6070]">
            <FiUserCheck size={18} />
          </span>

          <div className="relative min-w-0 flex-1">
            <div className="absolute right-0 top-0">
              <button
                aria-label="Menu"
                onClick={() => {
                  if (!disabled) {
                    setDropdownOpen(!dropdownOpen)
                  }
                }}
                className={`text-gray-400 hover:text-gray-600 ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
              >
                <FiMoreVertical size={18} />
              </button>

              {dropdownOpen && (
                <div className="absolute right-0 z-10 mt-2 w-40 rounded-md border border-gray-200 bg-white shadow-lg">
                  <button
                    className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setShowMore(true)
                      setDropdownOpen(false)
                    }}
                  >
                    Show more
                  </button>
                </div>
              )}
            </div>

            <div className="pr-6 text-[12px] font-medium uppercase tracking-wide text-dantzBlue">
              Dirk Representative at {officeLabel}
            </div>
            <div className="text-xs leading-relaxed text-gray-600">
              Kurfürstendamm 43, 10719 Berlin
            </div>
            <div className="text-xs text-gray-600">Deutschland</div>
          </div>
        </div>
      </div>

      {showMore && (
        <div className="relative mt-3 w-full max-w-full rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-medium text-gray-800">
              Additional Information
            </h3>
            <button
              aria-label="Close"
              onClick={() => setShowMore(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              <FiX size={18} />
            </button>
          </div>

          <div className="mb-4 mt-2 border-t border-gray-100"></div>

          <div className="mb-3 flex gap-4">
            <div className="min-w-0 flex-1">
              <label className="text-xs font-medium text-gray-500">Merger</label>
              <div className="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
                Dirk Dantz
              </div>
            </div>
            <div className="min-w-0 flex-1">
              <label className="text-xs font-medium text-gray-500">
                Country of registration
              </label>
              <div className="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
                Deutschland
              </div>
            </div>
          </div>

          <h4 className="mb-2 mt-5 text-[11px] font-medium uppercase tracking-wide text-gray-400">
            Mailing Address
          </h4>

          <div className="mb-3">
            <label className="text-xs font-medium text-gray-500">
              Address (Street &amp; house number)
            </label>
            <div className="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
              Kurfürstendamm 43
            </div>
          </div>

          <div className="mb-3 flex gap-4">
            <div className="min-w-0 flex-1">
              <label className="text-xs font-medium text-gray-500">City</label>
              <div className="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
                Berlin
              </div>
            </div>
            <div className="min-w-0 flex-1">
              <label className="text-xs font-medium text-gray-500">
                Postal Code
              </label>
              <div className="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
                10719
              </div>
            </div>
          </div>

          <div className="mb-3">
            <label className="text-xs font-medium text-gray-500">Country</label>
            <div className="mt-1 w-20 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
              DE
            </div>
          </div>

          <div className="mb-3">
            <label className="text-xs font-medium text-gray-500">
              Mailing Address
            </label>
            <div className="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
              Kurfürstendamm 43, Deutschland, 10719 Berlin
            </div>
          </div>

          <h4 className="mb-2 mt-5 text-[11px] font-medium uppercase tracking-wide text-gray-400">
            Contact
          </h4>

          <div className="flex gap-4">
            <div className="min-w-0 flex-1">
              <label className="text-xs font-medium text-gray-500">Phone</label>
              <div className="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
                +49 (30) 8877 3180
              </div>
            </div>
            <div className="min-w-0 flex-1">
              <label className="text-xs font-medium text-gray-500">E-Mail</label>
              <div className="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
                dantz@dantz-ip.com
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  )
}
